import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const rewindWorkflow: OpalApi<'RewindWorkflowV3', 200> = async ({
  params,
  requestBody,
}: Parameters<OpalApi<'RewindWorkflowV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflows/${params?.path.workflow_id}/rewind`,
    window.location.origin
  )
  url.search = queryString(params?.query)
  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
